var SocialLoginResponseStatus = /*#__PURE__*/ function(SocialLoginResponseStatus) {
    SocialLoginResponseStatus[SocialLoginResponseStatus["Success"] = 0] = "Success";
    SocialLoginResponseStatus[SocialLoginResponseStatus["Error"] = 1] = "Error";
    SocialLoginResponseStatus[SocialLoginResponseStatus["NotImplemented"] = 2] = "NotImplemented";
    SocialLoginResponseStatus[SocialLoginResponseStatus["LoadError"] = 3] = "LoadError";
    SocialLoginResponseStatus[SocialLoginResponseStatus["Unknown"] = 4] = "Unknown";
    SocialLoginResponseStatus[SocialLoginResponseStatus["UserCancelled"] = 5] = "UserCancelled";
    return SocialLoginResponseStatus;
}({});

export { SocialLoginResponseStatus as S };
